import { ENV } from "./../../utils/constant";
import { useEffect, useState } from "react";
import useLookupStore from "../../setup/store/useLookupStore";
import { useLookup } from "@services/shared";
import { sortedBy } from "../../utils/helper";
import { curriculumsVar, lookupVar } from "../../reactiveVars/coursemanagementVars";
import localforage from "localforage";

const useInitLookups = () => {
  const [loading] = useState(false);
  const { gradeLevels, getGradeLevels } = useLookup("grade_levels");
  const { schoolYears, getSchoolYears } = useLookup("school_years");
  const { curriculums, getCurriculums } = useLookup("curriculums");
  const { programs, getPrograms } = useLookup("programs");
  const { subjects, getSubjects } = useLookup("subjects");
  const { accreditations, getAccreditations } = useLookup("accreditations");
  const { courseStatus, getCourseStatus } = useLookup("course-status");
  const { skills, getSkills } = useLookup("skills");
  const { subSkills } = useLookup("sub_skills");
  const { teachers, getTeachers } = useLookup("teachers");
  const { parentTeachers, getParentTeachers } = useLookup("parent_teachers");
  const { gradingComponent, getGradingComponent } = useLookup("grading_component");
  const { objectiveType, getObjectiveType } = useLookup("objective_type");
  const { classes, getClasses } = useLookup("classes");

  // no API for these yet
  const { gradeApprovalStatus } = useLookup("grade_approval_status");
  const { organizations } = useLookup("organizations");

  const {
    setPrograms,
    setAccreditations,
    setCourseStatus,
    setCurriculums,
    setSubjects,
    setSchoolYears,
    setGradeLevels,
    setOrganizations,
    setGradeApprovalStatus,
    setSkills,
    setSubSkills,
    setTeachers,
    setParentTeachers,
    setGradingComponents,
    setObjectiveType,
    setClasses,
  } = useLookupStore();

  useEffect(() => {
    (async () => {
      try {
        if (ENV !== "local") await localforage.clear();

        getGradeLevels();
        getSchoolYears();
        getCurriculums();
        getPrograms();
        getSubjects();
        getAccreditations();
        getCourseStatus();
        getSkills();
        getTeachers();
        getParentTeachers();
        getGradingComponent();
        getObjectiveType();
        getClasses();
        // no API for these yet
        // getSubSkills();
        // getOrganizations();
        // getGradeApprovalStatus();
      } catch (error) {
        console.error("Failed to clear localForage:", error);
      }
    })();
    // Mount-only: fetch every lookup once; the get* fns aren't memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setGradeLevels(sortedBy(gradeLevels, "grade_level"));
    setSchoolYears(sortedBy(schoolYears, "name"));
    setCurriculums(sortedBy(curriculums, "curriculum_name"));
    setPrograms(sortedBy(programs, "program"));
    setAccreditations(sortedBy(accreditations, "name"));
    setCourseStatus(sortedBy(courseStatus, "name"));
    setSubjects(sortedBy(subjects, "name"));
    setSkills(sortedBy(skills, "name"));
    setSubSkills(sortedBy(subSkills, "name"));
    setTeachers(sortedBy(teachers, "first_name"));
    setParentTeachers(sortedBy(parentTeachers, "first_name"));
    setGradingComponents(sortedBy(gradingComponent, "name"));
    setObjectiveType(sortedBy(objectiveType, "name"));
    setClasses(sortedBy(classes, "class_name"));
    // setOrganizations(sortedBy(organizations, "organizations"));
    setSchoolYears(sortedBy(schoolYears, "name"));
    setGradeApprovalStatus(sortedBy(gradeApprovalStatus, "name"));

    // Organizations still hardcoded until org-scoped lookup is built
    const fake_orgs = [
      { id: "2381", name: "National Education Board" },
      { id: "2382", name: "High School Academy" },
    ];
    setOrganizations(sortedBy(fake_orgs, "name"));

    curriculumsVar(sortedBy(curriculums, "curriculum_name"));

    lookupVar({
      gradeLevels,
      schoolYears,
      curriculums,
      programs,
      subjects,
      accreditations,
      courseStatus,
      organizations,
      gradeApprovalStatus,
      skills,
      subSkills,
      teachers,
      gradingComponent,
      objectiveType,
      classes,
    });
    // This effect re-sorts each lookup and writes it back via its own setter;
    // listing parentTeachers/students (which it also sets) would self-trigger
    // an infinite loop, so deps are scoped to the source arrays it reads.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    gradeLevels,
    schoolYears,
    curriculums,
    programs,
    subjects,
    accreditations,
    courseStatus,
    organizations,
    gradeApprovalStatus,
    skills,
    subSkills,
    teachers,
    gradingComponent,
    objectiveType,
    classes,
  ]);

  return {
    loading,
  };
};

export default useInitLookups;
